import { Card, Form, Row, Tabs, TabsProps } from 'antd';

import '@features/Incentive/incentive.css';
import { ContainerDashboard } from './ContainerDashboard';
import { UserDashboard } from './UserDashboard';
import { KFSUserDashboard } from './KFSUserDashboard';
import { TransactionNewDashboard } from './TransactionNewDashboard';
import { TransactionPickupDashboard } from './TransactionPickupDashboard';
import { TransactionDropOffDashboard } from './TransactionDropOffDashboard';
import { useEffect } from 'react';
import { PATHS } from '@routing/routes';
import { useHistory } from 'react-router';
import { AccountSelector } from '@features/Account';
import { useSelector } from 'react-redux';
import { Roles } from 'common/constants';
import { ContainerDashboardCritical } from './ContainerDashboardCritical';
export const MainDashboard = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const accountState = useSelector(AccountSelector);
  const onFinish = async () => {
    console.log('');
  };

  const allowedUsers = [
    'admin@kfs.com',
    'agent_vic@kfs.com',
    'mayette@kfs.com',
    'erick@kfs.com',
    'manny@kfs.com',
    'michelle@kfs.com',
  ];

  useEffect(() => {
    if (!allowedUsers.includes(accountState?.Username || '')) {
      history.push(PATHS.Home.path);
    }
  }, [accountState]);

  const onChange = (key: string) => {
    console.log(key);
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Critical deliveries',
      children: <ContainerDashboardCritical />,
    },
    {
      key: '2',
      label: 'Container',
      children: <ContainerDashboard />,
    },
    {
      key: '3',
      label: 'Bookings - New',
      children: <TransactionNewDashboard />,
    },
    {
      key: '4',
      label: 'Bookings - for pickup',
      children: <TransactionPickupDashboard />,
    },
    {
      key: '5',
      label: 'Empty boxes - for drop-off',
      children: <TransactionDropOffDashboard />,
    },
    {
      key: '6',
      label: 'Customer list',
      children: <UserDashboard />,
    },
    {
      key: '7',
      label: 'KFS user list',
      children: <KFSUserDashboard />,
    },
  ];

  return (
    <div className="App">
      <Row justify="center" align="middle">
        <h1>Dashboard</h1>
      </Row>

      <Card>
        <Form name="referralForm" onFinish={onFinish} layout="vertical" form={form}>
          <Tabs defaultActiveKey="1" items={items} onChange={onChange} className="tabDashboard" />
        </Form>
      </Card>
    </div>
  );
};
